import { render, staticRenderFns } from "./SidePage.vue?vue&type=template&id=78412c58"
import script from "./SidePage.vue?vue&type=script&lang=js"
export * from "./SidePage.vue?vue&type=script&lang=js"
import style0 from "./SidePage.vue?vue&type=style&index=0&id=78412c58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports